export default "__VITE_ASSET__a4b4da6e__"